import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupsAppGroupIdRenameCacheKeys: AllRouteEndpoints[] = ["/apps/app_group", "/apps/app_groups"];
